import React, {Component} from 'react';
import { withRouter} from 'react-router-dom';
import IdleTimer from 'react-idle-timer';
import DialogBox from "./Shared/DialogBox";
import './App.css';
import LoginComponent from './LoginComponent/Login';
import AboutComponent from './AboutComponent/About';
import MainComponent from './MainComponent/Main';
import MainTeacherComponent from './TeachersComponent/Main';
import ResourcesComponent from './ResourcesComponent/Resources';
import StudentsComponent from './TeachersComponent/Students';
import AdminComponent from './AdminComponent/Admin';
import SchoolAdminComponent from './AdminComponent/SchoolAdmin';
import SchoolManagementComponent from './AdminComponent/SchoolManagement';
import ParentComponent from './ParentComponent/Parent';
import ContentComponent from './ContentComponent/Content';
import KSContent from "./ContentComponent/KidSpeak";
import MazeContent from "./ContentComponent/MazeContent";
import MazeCreator from "./ContentComponent/MazeCreator";
import MainStudentComponent from './StudentsComponent/Main';
import StudentDataComponent from './TeachersComponent/StudentData';
import PictureNaming from "./StudentsComponent/PictureNaming";
import WordSignSay from "./StudentsComponent/WordSignSay";
import PN1On1Student from "./StudentsComponent/PN1On1Student";
import PN1On1Teacher from "./TeachersComponent/PN1On1Teacher"
import PNManual from "./TeachersComponent/PNManual"
import PNGrading from "./TeachersComponent/PNGrading";
import KidSpeak from "./StudentsComponent/KidSpeak";
import KSGrading from "./TeachersComponent/KSGrading/KSGrading";
import MazeComponent from './StudentsComponent/Maze1';
import SlashTestComponent from './StudentsComponent/SlashTest';
import WordMarkComponent from './StudentsComponent/WordMark';
import WordMark2Component from './StudentsComponent/WordMark2';
import CopyRight from "./StudentsComponent/CopyRight";
import CRGrading from "./TeachersComponent/CRGrading/CRGrading";
import WSSGrading from "./TeachersComponent/WSSGrading/WSSGrading";
import KidSign from "./StudentsComponent/KidSign";
import KidSignGrading from "./TeachersComponent/KidSignGrading/KidSignGrading";
import NeedsAssessmentComponent from './NeedsAssessmentComponent/NeedsAssessment';
import AnimalsComponent from './StudentsComponent/Animals'


import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import RequestAccountComponent from './RequestAccountComponent/RequestAccount';
import HelpComponent from './HelpComponent/Help';
import WordMarkGrading from "./TeachersComponent/WordMarkGrading";
import WordMark2Grading from "./TeachersComponent/WordMark2Grading";
import configureStore from "./Shared/configureStore";
import { PersistGate } from 'redux-persist/integration/react';
import {Provider} from 'react-redux';
import REST from "./Shared/REST";

let idleDuration = 60 * 40;

class App extends Component {

    constructor(props) {
        super(props);

        let {store, persistor} = configureStore();

        this.state = {
            user: {},
            student: {},
            classId: 0,
            store: store,
            persistor: persistor,
            timeout: 1000 * idleDuration,
            modalDialog: false,
            responseContent:'',
            userLoggedIn: false,
            isTimedOut: false
        };

        this.idleTimer = null
        this.onAction = this._onAction.bind(this)
        this.onActive = this._onActive.bind(this)
        this.onIdle = this._onIdle.bind(this)
    }

    _onAction(e) {
        //console.log('user did something', e)
        this.setState({isTimedOut: false});
    }

    _onActive(e) {
        //console.log('user is active', e);
        this.setState({isTimedOut: false});
    }

    _onIdle(e) {
        console.log('user is idle', e);
        const isTimedOut = this.state.isTimedOut;
        if (isTimedOut) {
            REST.logout().then((response) => {
                localStorage.removeItem('token');
                this.setState({
                    modalDialog: false,
                });
                window.location.reload();

            }, (error) => {
                localStorage.removeItem('token');
                localStorage.clear();
                this.props.history.push("/login");
            });
        } else {
            if(window.location.pathname!=='/login' &&
                window.location.pathname!=='/resources' &&
                window.location.pathname!=='/request-account' &&
                window.location.pathname!=='/help'
               ) {
                this.setState({
                    modalDialog: true,
                    responseContent: 'AvenuePM has not been used for 40 minutes. Your session will soon end automatically.'
                });
                this.idleTimer.reset();
                this.setState({isTimedOut: true});
            }
        }

    }

    setUser = (user) => {
        this.setState({user: user});

    };

    handleStudentClick = (student, classId) => {
        this.setState({student: student, classId: classId});
    };

    handleAddStudent = (classId) => {
        this.setState({classId: classId});
    };

    render() {
        return (
            <Provider store={this.state.store}>
                <PersistGate persistor={this.state.persistor}>
                    <IdleTimer
                        ref={ref => { this.idleTimer = ref }}
                        element={document}
                        onActive={this.onActive}
                        onIdle={this.onIdle}
                        onAction={this.onAction}
                        debounce={250}
                        timeout={this.state.timeout} />
                    <DialogBox notificationModal modalOpen={this.state.modalDialog} sectionContent={this.state.responseContent} closeClick={(active)=>{this.setState({modalDialog: active}); }} />
                    <Router>
                        <Switch>
                            <Route path="/" exact render={props =>
                                <MainComponent persistor={this.state.persistor} {...props} userCallback={this.setUser}/>
                            }/>
                            <Route path="/login" exact render={props =>
                                <LoginComponent {...props} callback={this.setUser}/>
                            }/>
                            <Route path="/about" exact render={props =>
                                <AboutComponent {...props} callback={this.setUser}/>
                            }/>
                            <Route path="/resources" exact component={ResourcesComponent}/>
                            <Route path="/request-account" exact component={RequestAccountComponent}/>
                            <Route path="/help" exact component={HelpComponent}/>
                            <Route path="/teacher" exact render={props =>
                                <MainTeacherComponent persistor={this.state.persistor} strict={true} {...props}
                                                      handleAddStudent={this.handleAddStudent}
                                                      handleStudentClick={this.handleStudentClick}
                                                      callback={this.setUser}
                                                      user={this.state.user}/>
                            }/>
                            <Route path="/teacher/student" exact render={props =>
                                <StudentsComponent {...props} edit={true} student={this.state.student}
                                                   classId={this.state.classId}/>
                            }/>
                            <Route path="/teacher/add-student" exact render={props =>
                                <StudentsComponent {...props} edit={false} classId={this.state.classId}/>
                            }/>
                            <Route path="/teacher/student/data/maze" exact render={props =>
                                <StudentDataComponent type={1} student={this.state.student}/>
                            }/>
                            <Route path="/teacher/student/data/slashtest" exact render={props =>
                                <StudentDataComponent type={2} student={this.state.student}/>
                            }/>
                            <Route path="/teacher/student/data/wordmark" exact render={props =>
                                <StudentDataComponent type={3} student={this.state.student}/>
                            }/>
                            <Route path="/teacher/student/data/kidspeak" exact render={props =>
                                <StudentDataComponent type={4} student={this.state.student}/>
                            }/>
                            <Route path="/teacher/student/data/picturenaming/manual" exact render={props =>
                                <StudentDataComponent type={5} PNModel={"manual"} student={this.state.student}/>
                            }/>
                            <Route path="/teacher/student/data/picturenaming/1On1" exact render={props =>
                                <StudentDataComponent type={5} PNModel={"1On1"} student={this.state.student}/>
                            }/>
                            <Route path="/teacher/student/data/picturenaming/computer" exact render={props =>
                                <StudentDataComponent type={5} PNModel={"computer"} student={this.state.student}/>
                            }/>
                            <Route path="/teacher/student/data/copyright" exact render={props =>
                                <StudentDataComponent type={6} student={this.state.student}/>
                            }/>
                            <Route path="/teacher/student/data/wordsignsay" exact render={props =>
                                <StudentDataComponent type={7} student={this.state.student}/>
                            }/>
                            <Route path="/teacher/student/data/kidsign" exact render={props =>
                                <StudentDataComponent type={8} student={this.state.student}/>
                            }/>
                            <Route path="/teacher/student/data/wordmark2" exact render={props =>
                                <StudentDataComponent type={9} student={this.state.student}/>
                            }/>
                            <Route path="/student" exact render={props =>
                                <MainStudentComponent persistor={this.state.persistor} role={"student"} {...props} />
                            }/>
                            <Route path="/parent" exact render={props =>
                                <ParentComponent persistor={this.state.persistor} {...props} />
                            }/>
                            <Route path="/student/apps/picturenaming" exact render={props =>
                                <PictureNaming {...props} />
                            }/>
                            <Route path="/student/apps/copyright" exact render={props =>
                                <CopyRight {...props} />
                            }/>
                            <Route path="/student/apps/kidsign" exact render={props =>
                                <KidSign {...props} />
                            }/>
                            <Route path="/student/apps/wordsignsay" exact render={props =>
                                <WordSignSay {...props} />
                            }/>
                            <Route path="/student/apps/pn-1-1" exact render={props =>
                                <PN1On1Student {...props} />
                            }/>
                            <Route path="/student/apps/kidspeak" exact render={props =>
                                <KidSpeak {...props} />
                            }/>
                            <Route path="/teacher/apps/pn-1-1" exact render={props =>
                                <PN1On1Teacher persistor={this.state.persistor} {...props} />
                            }/>
                            <Route path="/teacher/apps/pn-manual" exact render={props =>
                                <PNManual persistor={this.state.persistor} {...props} />
                            }/>
                            <Route path="/teacher/apps/pn-grading" exact render={props =>
                                <PNGrading persistor={this.state.persistor} user={this.state.user} {...props} />
                            }/>
                            <Route path="/teacher/apps/ks-grading" exact render={props =>
                                <KSGrading persistor={this.state.persistor} user={this.state.user} {...props} />
                            }/>
                            <Route path="/teacher/apps/wm-grading" exact render={props =>
                                <WordMarkGrading persistor={this.state.persistor} user={this.state.user} {...props}/>
                            }/>
                            <Route path="/teacher/apps/wm2-grading" exact render={props =>
                                <WordMark2Grading persistor={this.state.persistor} user={this.state.user} {...props}/>
                            }/>
                            <Route path="/teacher/apps/cr-grading" exact render={props =>
                                <CRGrading persistor={this.state.persistor} user={this.state.user} {...props}/>
                            }/>
                            <Route path="/teacher/apps/wss-grading" exact render={props =>
                                <WSSGrading persistor={this.state.persistor} user={this.state.user} {...props}/>
                            }/>
                            <Route path="/teacher/apps/kss-grading" exact render={props =>
                                <KidSignGrading persistor={this.state.persistor} user={this.state.user} {...props}/>
                            }/>
                            <Route path="/student/tasks/maze" exact component={MazeComponent}/>
                            <Route path="/student/tasks/slashtest" exact component={SlashTestComponent}/>
                            <Route path="/student/tasks/wordmark" exact component={WordMarkComponent}/>
                            <Route path="/student/tasks/wordmark2" exact component={WordMark2Component}/>
                            <Route path="/admin" exact render={props =>
                                <AdminComponent {...props}
                                                user={this.state.user}/>
                            }/>
                            <Route path="/school-admin" exact render={props =>
                                <SchoolAdminComponent persistor={this.state.persistor} strict={true} {...props}
                                                      handleAddStudent={this.handleAddStudent}
                                                      handleStudentClick={this.handleStudentClick}
                                                      callback={this.setUser}
                                                      user={this.state.user}/>
                            }/>
                            <Route path="/content" exact render={props =>
                                <ContentComponent {...props} />
                            }/>
                            <Route path="/content/maze-creator" exact render={props =>
                                <MazeCreator {...props} />
                            }/>
                            <Route path="/school-management" exact render={props =>
                                <SchoolManagementComponent {...props} />
                            }/>
                            <Route path="/content/kidspeak" exact render={props =>
                                <KSContent persistor={this.state.persistor} {...props} />
                            }/>
                            <Route path="/content/maze" exact render={props =>
                                <MazeContent persistor={this.state.persistor} {...props} />
                            }/>
                            <Route path="/needs-assessment" exact render={props =>
                                <NeedsAssessmentComponent {...props} />
                            }/>
                            <Route path="/animals" exact render={props =>
                                <AnimalsComponent {...props} />
                            }/>
                            <Route component={NoMatch}/>
                        </Switch>
                    </Router>
                </PersistGate>
            </Provider>
        );
    }
}

const NoMatch = ({location}) => (
    <div>
        <h3>
            No match for <code>{location.pathname}</code>
        </h3>
    </div>
);

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/App.js